import * as S from './styles';

import { useState } from 'react';

import ReprocessarPagamento from '../../ReprocessarPagamento';
import BookingsRepository from '../../../repositories/bookingsRepository';
import { useGlobal } from '../../../contexts/globalContext';
import GradeIcon from '@material-ui/icons/Grade';
import PlaceIcon from '@material-ui/icons/Place';
import Loader from '../../Loader';
import { useHistory } from 'react-router-dom';
import Auth2faModal from '../../Auth2FaModal';

import { ThemeButton } from '../../ThemeButton/styles';

import { format, parseISO } from 'date-fns';
import { pt } from 'date-fns/locale';
import { safeFormat } from '../../../utils/dateHelpers';

const getOldFormatData = (booking) => {
	const reservations =
		booking?.HotelReservationsType ||
		booking?.hotelBookingResponse?.HotelReservationsType;

	if (!reservations) return null;

	const roomStay = reservations?.HotelReservations?.[0]?.RoomStaysType?.RoomStays?.[0];
	if (!roomStay) return null;

	return {
		hotelName: roomStay?.BasicPropertyInfo?.HotelRef?.HotelName,
		imageUrl: roomStay?.BasicPropertyInfo?.ImageURL,
		rating: roomStay?.BasicPropertyInfo?.Award?.Rating,
		address: roomStay?.BasicPropertyInfo?.Address?.AddressLine,
		roomName: roomStay?.RoomTypes?.[0]?.RoomName,
		roomDescription: roomStay?.RoomTypes?.[0]?.RoomDescription?.Description,
		cancelPolicy: roomStay?.RatePlans?.[0]?.CancelPenalties?.[0]?.PenaltyDescription?.Description,
	};
};

const getOrinterFormatData = (booking) => {
	const bookingHotel = booking?.bookingHotels?.[0];
	const room = bookingHotel?.rooms?.[0];
	const service = booking?.bookingService;
	const detail = booking?.hotelDetail;
	const roomDetail = booking?.roomsDetail?.[0];

	// Parse hotel name from description (e.g. "Reserva Hotel Grand Plaza")
	const parseHotelName = () => {
		const desc = service?.name || booking?.description || '';
		const match = desc.match(/^Reserva Hotel\s+(.+)$/i);
		return match ? match[1] : null;
	};

	const hotelName = bookingHotel?.hotel?.name || booking?.hotelName || parseHotelName() || 'Hotel';
	const checkIn = booking?.checkIn || service?.hotel?.checkIn;
	const checkOut = booking?.checkOut || service?.hotel?.checkOut;

	if (!bookingHotel && !service?.hotel) return null;

	// Build address string from detail
	const buildAddress = () => {
		const addr = detail?.address;
		if (!addr) return null;
		const cityName = typeof addr.city === 'string' ? addr.city : addr.city?.name;
		const parts = [addr.address, addr.number, addr.neighborhood, cityName].filter(p => p && typeof p === 'string');
		return parts.length > 0 ? parts.join(', ') : null;
	};

	// Get first image URL
	const getImageUrl = () => {
		const images = detail?.images;
		if (!images || images.length === 0) return null;
		return images[0]?.large || images[0]?.medium || images[0]?.standard || images[0]?.small || null;
	};

	// Get cancellation policy text
	const getCancelPolicy = () => {
		const policies = roomDetail?.cancellationPolicies;
		if (!policies) return null;
		return policies.description || policies.text || null;
	};

	return {
		hotelName,
		imageUrl: getImageUrl(),
		rating: detail?.stars,
		address: buildAddress(),
		roomName: roomDetail?.roomType?.name || room?.roomType?.name,
		roomDescription: roomDetail?.boardType?.name || room?.boardType?.name,
		cancelPolicy: getCancelPolicy(),
		checkIn,
		checkOut,
		adults: service?.hotel?.adults,
		children: service?.hotel?.children,
		participants: service?.participants,
	};
};

const HotelTravelsCard = ({ booking = [], departureDate, arrivalDate, coinAlias}) => {
	let history = useHistory();

	const bookingsRepository = new BookingsRepository();
	const { showAlert } = useGlobal();

	const [openDialogReprocessar, setOpenDialogReprocessar] = useState(false);
	const [openLoader, setOpenLoader] = useState(false);
	const [openModal2fa, setOpenModal2fa] = useState(false);

	const closeModal2fa = () => setOpenModal2fa(false);

	const onChangeOpenDialogReprocessar = (open) => setOpenDialogReprocessar(open);

	const getStatusTranslate = (status) => {
		switch (status) {
			case 1:
				return 'pendente';
			case 2:
				return 'emitido';
			case 3:
				return 'expirado';
			case 4:
				return 'finalizado';
			case 5:
				return 'cancelado';
			default:
				break;
		}
	};

	const reprocessar = () => {
		if (
			(booking.paymentTransaction === null ||
				booking.paymentTransaction === undefined) &&
			booking.cashTotalValue > 0
		) {
			onChangeOpenDialogReprocessar(true);
		} else {
			setOpenLoader(true);
			bookingsRepository
				.reprocessarPagamento(booking.bookingCode, {})
				.then((res) => {
					setOpenLoader(false);
					sessionStorage.setItem('@bookingCompleted', JSON.stringify(res));
					switch (res.status) {
						case 200:
							history.push('/busca/finalizado');
							break;
						case 201:
							if (res.data.auth2fa) {
								if (res.data.redirectAuth2fa !== null) {
									setOpenLoader(true);
									window.location.replace(res.data.redirectAuth2fa);
								} else {
									setOpenModal2fa(true);
								}
							} else {
								history.push('/busca/finalizado');
							}
							break;
						default:
							break;
					}
				})
				.catch((err) => {
					setOpenLoader(false);
					switch (err?.response?.status) {
						case 400:
							showAlert('Há algo de errado nos seus dados, verifique!');
							break;
						case 401:
							history.push('/session-expires');
							break;
						case 409:
							sessionStorage.setItem(
								'@bookingError',
								JSON.stringify(err.response.data.error)
							);
							sessionStorage.setItem(
								'reprocessar',
								JSON.stringify({ reprocessar: true })
							);
							history.push('/busca/booking-error');
							break;
						case 504:
							sessionStorage.setItem(
								'@bookingError',
								JSON.stringify('Tempo expirou, tente novamente!')
							);
							sessionStorage.setItem(
								'reprocessar',
								JSON.stringify({ reprocessar: true })
							);
							history.push('/busca/booking-error');
							break;
						default:
							showAlert('error', `Compra não processada, por favor, tente novamente!`);
							break;
					}
				});
		}
	};

	const reenviarVoucher = (locator) => {
		bookingsRepository
			.reenviarVoucher(locator)
			.then((res) =>
				showAlert('success', 'Voucher reenviado, verifique seu e-mail!')
			)
			.catch((err) => showAlert('error', 'Houve algum erro, tente novamente!'));
	};

	// Extract hotel data from old (Omnibees) or new (Orinter) format
	const hotelData = getOldFormatData(booking) || getOrinterFormatData(booking);

	const starsRatingInteger = Math.round(hotelData?.rating || 0);
	const stars = Array(isNaN(starsRatingInteger) ? 0 : starsRatingInteger)
		.fill()
		.map((_, idx) => idx);

	const formatDate = (dateStr) => {
		return safeFormat(dateStr, 'dd/MM/yyyy', { locale: pt });
	};

	return (
		<S.BlankCard>
			<ReprocessarPagamento
				open={openDialogReprocessar}
				onClose={onChangeOpenDialogReprocessar}
				booking={booking}
			/>
			<Loader openLoader={openLoader} />
			<Auth2faModal
				open={openModal2fa}
				onClose={closeModal2fa}
				booking={{ data: booking }}
				type='reprocessar'
			/>
			<S.CardHeader>
				<S.Title>
					Código da reserva: {booking?.bookingCode}
					<span className='subtitle'>
						Data da reserva: {safeFormat(booking?.bookingDateStr, 'dd/MM/yyyy', { locale: pt })}
					</span>
				</S.Title>
				{booking?.statusId && (
					<S.StatusContainer>
						{booking?.statusId === 1 && (
							<ThemeButton className='reprocessar' onClick={reprocessar}>
								Reprocessar Pagamento
							</ThemeButton>
						)}
						{booking?.statusId === 2 && (
							<ThemeButton
								className='reprocessar'
								onClick={() => reenviarVoucher(booking?.bookingCode)}
							>
								Reenviar Voucher
							</ThemeButton>
						)}

						<S.Status className={`status ${getStatusTranslate(booking.statusId)}`}>
							{getStatusTranslate(booking.statusId)}
						</S.Status>
					</S.StatusContainer>
				)}
			</S.CardHeader>
			<S.Subtitle>Detalhes do hotel</S.Subtitle>

			<S.FlightSummaryCardDetails>
				<div>
					{hotelData?.imageUrl ? (
						<img
							src={hotelData.imageUrl}
							alt='imagem do hotel'
						/>
					) : (
						<div style={{
							width: 200,
							height: 150,
							backgroundColor: '#f0f0f0',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							color: '#999',
							fontSize: 14,
							borderRadius: 4,
						}}>
							Imagem não disponibilizada pelo fornecedor
						</div>
					)}
				</div>
				<S.HotelDetails item xs={12}>
					<div className='content'>
						{stars.length > 0 && (
							<div className='stars'>
								{stars.map((star, index) => (
									<GradeIcon fontSize='small' key={index} />
								))}
							</div>
						)}
						<div className='hotel-details'>
							<span className='hotel-name'>
								{hotelData?.hotelName || 'Hotel'}
							</span>
						</div>
						{hotelData?.address && (
							<div className='location'>
								<span>
									<PlaceIcon fontSize='small' />
									{hotelData.address}
								</span>
							</div>
						)}
					</div>
					<div className='roomDetails'>
						{hotelData?.roomName && (
							<span>
								<b>Quarto: {hotelData.roomName}</b>
							</span>
						)}
						{hotelData?.roomDescription && (
							<span>
								Descrição: {hotelData.roomDescription}
							</span>
						)}
						{hotelData?.checkIn && hotelData?.checkOut && (
							<span>
								<b>Check-in:</b> {formatDate(hotelData.checkIn)}{' '}
								<b>Check-out:</b> {formatDate(hotelData.checkOut)}
							</span>
						)}
						{hotelData?.cancelPolicy && (
							<span className='cancel-policies'>
								<b>Politica de cancelamento: </b>
								{hotelData.cancelPolicy}
							</span>
						)}
					</div>
				</S.HotelDetails>
			</S.FlightSummaryCardDetails>

			<S.BottomInfos>
				{(booking.passengers || hotelData?.participants) && (
					<S.Travellers>
						<S.Subtitle>VIAJANTES</S.Subtitle>
						{(booking.passengers || hotelData?.participants || []).map((passenger, idx) => (
							<S.TravellerName key={idx}>{`${passenger.name || passenger.firstName || ''} ${passenger.lastName || ''}`}</S.TravellerName>
						))}
					</S.Travellers>
				)}
				{!booking.pointsTotalValue && !booking.cashTotalValue && booking?.BookingBySource?.[0]?.TotalFare?.Total && (
					<S.ValorTotal>
						Total: R${' '}
						{booking?.BookingBySource?.[0]?.TotalFare?.Total?.toLocaleString('pt-BR') || "N/A"}
					</S.ValorTotal>
				)}
				{booking.pointsTotalValue ? (
					<S.ValorTotal>
						Valor em {coinAlias}: {booking.pointsTotalValue}
					</S.ValorTotal>
				) : (
					''
				)}
				{booking.cashTotalValue ? (
					<S.ValorTotal>
						{' '}
						Valor em R$: {booking.cashTotalValue.toLocaleString('pt-BR')}
					</S.ValorTotal>
				) : (
					''
				)}
			</S.BottomInfos>
			{booking.bookingExpirationDate && (
				<S.ExpirationDate>
					{booking.purchaseId !== null && booking.purchaseId !== undefined && (
						<S.Title>
							<span className='subtitle-locator'>
								Locator: {booking.locatorSupplier || booking.locatorProvider}
							</span>
						</S.Title>
					)}
					{booking.statusId === 1 && (
						<span>
							Esta reserva expira em: {safeFormat(booking?.bookingExpirationDate, 'dd/MM/yyyy HH:mm', { locale: pt })}
						</span>
					)}
				</S.ExpirationDate>
			)}
		</S.BlankCard>
	);
};

export default HotelTravelsCard;
